import React from "react";

type MissingItemData = {
    field: string;
}
const MissingItem: React.FC<MissingItemData> = ({ field }) => {
    return (
        <div style={{
            border: '1px solid #ff9999',
            borderRadius: '5px',
            backgroundColor: '#ffdddd',
            color: '#990000',
            display: 'inline-block',
            padding: '2px 5px 2px 5px',
            fontSize: '10px',
            fontWeight: 'bold'
        }} title={'Contact is missing [' + field + ']'}>Missing Data</div>
    );
};


export default MissingItem;